<template>
    <panel-template :have-padding="false">
        <template #bradcrumbs>
            <ui-breadcrumbs>
                <template #left> Perfil </template>
            </ui-breadcrumbs>
        </template>
        <template #content>
            <div
                :class="statusClass" 
                class="modal-status">
                <div class="overlay"/>
                <div class="content">
                    <!--carregamento ao salvar-->
                    <section class="box radius"  >
                        <ui-load-indicator
                            v-if="!success"
                            bg-color="#e7e9f4"
                            color="#69D296"
                            :h="50"
                            :stroke="8" />

                        <span :class="statusIcon" class="success-icon">
                            <i aria-hidden='true' class="fal fa-check-circle"/>
                        </span>
                    </section>
                </div>
            </div>
            <div class="page-body">
                <!--carregamento ao iniciar-->
                <div v-if="carregandoTelaPrincipal" id="carregamento-inicial">
                    <div class="icon-carregamento-inicial">
                        <ui-load-indicator
                            bg-color="#e7e9f4"
                            color="#69D296"
                            :h="50"
                            :stroke="8" />
                    </div>
                </div>
                <!-- <ui-sidebar-float name="points" title="Extrato de pontos" icon = "fas fa-trophy">
                    <group-points />
                </ui-sidebar-float> -->
                <main>
                    <article>
                        <aside>
                            <!-- ************************
                            **** area de imagem e dados *
                            **************************-->
                            <span class="divider-shadow"/>
                            <user-profile :img-avatar="imgAvatar" :team='userDataProfile.team' :teans='userDataProfile.teans' :total-points="totalPoints" :user-data='userDataProfile' :user-id="userId" :blocked ="userModel.status == 'inactive'" @imput="imageAvatar" @showpoints="showPointsSidebar"/>
                            <!-- ****************
                            **** Botões de menu *
                            ******************-->

                            <nav class="row-2">
                                <div v-for="pag in pagination" :key="pag.name">
                                    <button
                                        v-if="pag.show"
                                        style="width: 100%"
                                        :class="{
                                            active: atualPage == pag.name,
                                        }"
                                        @click="chagePage(pag.name)" >
                                        <i aria-hidden='true' class="fas fa-caret-right"/>
                                        {{ pag.legend }}
                                    </button>
                                </div>
                            </nav>

                            <!-- *****************
                            * fim Botões de menu *
                            *******************-->
                        </aside>
                        <section>
                            <div class='title-icon'>
                                <h1>
                                    <i aria-hidden='true' class="fal fa-user-circle"/>
                                    Editar dados do Perfil
                                </h1>
                                <div v-if="userId && getLocalStorage.user_group == 'admin'">
                                    <user-manager :user="userModel" :groups="groups" :user-logged-group="getLocalStorage.user_group" @imput="bloquear" @getData="getData" />
                                </div>
                            </div>
                            <!-- **************
                            * dados do usuario*
                            *************** -->
                            <div
                                v-if="atualPage == 'personal-data'"
                                class="page" >
                                <user-data :user-model="userModel" :cpf-invalido="cpfInvalido" @imput="mensageErros"/>
                                
                            </div>
                            <!-- **************
                            * Contatos ********
                            *************** -->
                            <div
                                v-else-if="atualPage == 'contact-data'"
                                class="page">
                                <user-contact :user-model="userModel"/>
                            </div>
                            <!-- ************
                            * endereço ******
                            ************** -->
                            <div
                                v-else-if="atualPage == 'address'"
                                class="page"
                                style="overflow: hidden ">
                                <userAddress :user-model="userModel"  @click="mensageErros('cpf', '')"/>
                            </div>
                            <!-- **************
                            * dados de acesso *
                            *************** -->
                            <div
                                v-else-if="atualPage == 'access-data'"
                                class="page"
                            >
                                <user-access-data :user-model="userModel"  @imput="mensageErros"/>
                            </div>

                            <!--***************** 
                            campos personalizados 
                            *******************-->
                            <div
                                v-else-if="atualPage == 'campos-personalizados' && userModel.fields"
                                class="page fieldOverflow">

                                <div v-for="tip in getTypeCampos" :key="tip.id">                                  
                                    <div v-for="campos in getCamposPersonalizados" :key="campos.id">
                                        <form  v-if="campos.item_fields_name == tip.campos">
                                            <div>
                                                <span v-if="campos.field.type == 'text'">
                                                    <ui-input
                                                        v-model="setTypeCampos[campos.item_fields_name]"
                                                        :design="{'danger': tip.setRequired && setTypeCampos[campos.item_fields_name] == '' ? true : false}"
                                                        type="text"  
                                                        :label="campos.field.name + (campos.field.required ? '' : ' (opcional)')" 
                                                        :required="campos.field.required" />
                                                </span>
                                                <ui-input class='none'/>
                                            </div>
                                            <div>
                                                <span v-if="campos.field.type == 'money'">
                                                    <ui-input-money
                                                        v-model="setTypeCampos[campos.item_fields_name]"
                                                        :design="{'danger': tip.setRequired && setTypeCampos[campos.item_fields_name] == '' ? true : false}"
                                                        :type="campos.field.type"  
                                                        :label="campos.field.name + (campos.field.required ? '' : ' (opcional)')" 
                                                        :required="campos.field.required"
                                                        class="money" />
                                                </span>
                                                
                                            </div>
                                            <div v-if="campos.field.type == 'email'">
                                                <ui-input
                                                    v-model="setTypeCampos[campos.item_fields_name]" 
                                                    :type="campos.field.type"
                                                    :required="campos.field.required"
                                                    :design="{'danger': tip.setRequired && setTypeCampos[campos.item_fields_name] == '' ||
                                                        !validEmail(setTypeCampos[campos.item_fields_name])}"
                                                    :label="campos.field.name + (campos.field.required ? '' : ' (opcional)')" />
                                            </div>
                                            
                                            <div v-if="campos.field.type == 'date'"  class='camp-date'>
                                                <ui-datepicker
                                                    v-model="setTypeCampos[campos.item_fields_name]" 
                                                    :required="campos.field.required"
                                                    :value="setTypeCampos[campos.item_fields_name]"
                                                    :label="campos.field.name + (campos.field.required ? '' : ' (opcional)')"
                                                    :context="'notFuture'"
                                                    :min-date='new Date(1900, 0, 1)' size="md" />
                                            </div>

                                            <div v-if="campos.field.type == 'textarea'">
                                                <label>
                                                    <ui-textarea
                                                        v-if="campos.field.options.options.rows"
                                                        v-model="setTypeCampos[campos.item_fields_name]"
                                                        :required="campos.field.required"
                                                        :rows="campos.field.options.options.rows"
                                                        :label="campos.field.name + (campos.field.required ? '' : ' (opcional)')"
                                                        :design="{'danger': tip.setRequired && setTypeCampos[campos.item_fields_name] == '' ? true : false }" />
                                                    <ui-textarea
                                                        v-else
                                                        v-model="setTypeCampos[campos.item_fields_name]"
                                                        :required="campos.field.required"
                                                        :rows="campos.field.options.options.rows"
                                                        :label="campos.field.name + (campos.field.required ? '' : ' (opcional)')"
                                                        :design="{'danger': tip.setRequired && setTypeCampos[campos.item_fields_name] == '' ? true : false}" />
                                                </label>
                                            </div>

                                            <div v-if="campos.field.type == 'tel'">
                                                <ui-input
                                                    v-model="setTypeCampos[campos.item_fields_name]" type="text" mask='(##) #####-####'
                                                    :required="campos.field.required"
                                                    placeholder='(00) 00000-0000'
                                                    :design="{'danger': tip.setRequired && setTypeCampos[campos.item_fields_name] == '' ? true : false}" 
                                                    :label="campos.field.name + (campos.field.required ? '' : ' (opcional)')" />
                                            </div>

                                            <div v-if="campos.field.type == 'select'">
                                                <ui-select
                                                    v-model="setTypeCampos[campos.item_fields_name]"
                                                    :required="campos.field.required" 
                                                    :label="campos.field.name + (campos.field.required ? '' : ' (opcional)')" 
                                                    :design="{'danger': tip.setRequired && setTypeCampos[campos.item_fields_name] == '' ? true : false}" >
                                                    <option
                                                        v-for="options in campos.field.options.options" :key="options"
                                                        :value="options"
                                                        :selected="options == setTypeCampos[campos.item_fields_name]"
                                                    >
                                                        {{options}}
                                                    </option>
                                                </ui-select>
                                            </div> 
                                        </form>
                                    </div>
                                </div>
                                <!--***************** 
                                campos personalizados 
                                *******************-->
                            </div>

                            <div class="actions">
                                <div :class="{'tooltip': buttonDisabled}">
                                    <ui-button
                                        design="success lg"
                                        :disabled="buttonDisabled || saveLoading"
                                        @click="saveData">
                                        Salvar Alterações
                                    </ui-button>
                                    <div class="tooltiptext">
                                        {{message}}
                                    </div>
                                </div>
                            </div>
                        </section>
                    </article>
                    <div>
                        <ui-page-message
                            v-if="userError"
                            class="erroMessage"
                            icon="fad fa-user-slash"
                            icon-size="60"
                            :bg="true"
                            text="Este usuário não existe em nosso sistema" />
                    </div>
                    <time>
                        Último Acesso: {{ lastAccess[1] }} às
                        {{ lastAccess[2] }} - Cadastrado em:
                        {{ createdAt[1] }} às {{ createdAt[2] }}
                    </time>
                </main>
            </div>
            <ui-modal-message
                :icon-circle="true"
                service="user"
                icon="fal fa-exclamation-triangle" 
                name="delete-user"
                :title="`${userModel.first_name} será excluído(a) do sistema. Deseja realmente excluir?`"
                btn-type="danger"
                btn-text="Deletar"
                color-circle='circle-danger' />
            <ui-alert
                :name="`campos-required-profile`"
                :title="`Existem campos a serem preenchidos`"
                :text="`Por favor preencher os campos requeridos`" 
                btn-type="danger" />
            <ui-alert
                :name="`manager-not-modify`"
                :title="`Você não pode modificar o perfil de um gerente.`"
                :text="`Remova-o para mover todos os dados relacionados para outro gerente e então recrie-o no cargo desejado`" 
                btn-type="danger" />
            <ui-alert
                :name="`campos-message-error`"
                :title="`Existem campos a serem preenchidos`"
                :text="msgError" 
                btn-type="danger" />

            <ui-points-sidebar :data="userPoints" />
        </template>
    </panel-template>
</template>

<script>
import PanelTemplate                                                                    from '@/templates/page-panel-center'
import helpers                                                                          from '@/mixins/helpers'
import uiPointsSidebar                                                                  from './components/points-feed-sidebar'
import uiPageMessage                                                                    from "@/components/ui/page-message"
import { uiSelect, uiInput, uiDatepicker, uiTextarea, uiInputMoney                    } from '@/components/ui/form'
import { uiLoadIndicator, uiBreadcrumbs, uiAlert                                      } from '@/components/ui'
import { uiButton                                                                     } from '@/components/ui/buttons'
import { uiModalMessage                                                               } from '@/components/ui/modal'
import { user                                                                         } from '@/services/axios'
import { storage                                                                      } from '@/services/storage'
import { mapActions, mapGetters                                                       } from 'vuex'
import { userData, userAddress, userContact, userAccessData, userManager, userProfile } from './components/form-data'

export default {
    name: 'ui-profile',
    components: {
        PanelTemplate,
        uiPageMessage,
        uiBreadcrumbs,
        uiModalMessage,
        uiButton,
        uiAlert,
        uiInput,
        uiTextarea,
        uiSelect,
        uiDatepicker,
        uiLoadIndicator,
        uiPointsSidebar,
        userData,
        userContact,
        userAddress,
        userAccessData,
        userManager,
        userProfile,
        uiInputMoney
    },
    mixins: [helpers],
    data() {
        return {
            carregandoTelaPrincipal: true,
            carregandoImg: false,
            atualPage: 'personal-data',
            dangerInput: {},
            pagination: [
                { name: 'personal-data',         legend: 'Dados Pessoais' ,     show: true  },
                { name: 'contact-data',          legend: 'Dados de Contato',    show: true  },
                { name: 'address',               legend: 'Endereço',            show: true  },
                { name: 'access-data',           legend: 'Dados de Acesso',     show: true  },
                { name: 'campos-personalizados', legend: 'Outras Informações',  show: false },
            ],
            teans: {},
            dinamics: [],
            loading: false,
            lastAccess: [],
            statusClass: '',
            statusIcon: '',
            success: false,
            imgAvatar: '',
            dirtyData: {},
            cleanData: {},
            createdAt: [],
            erros: {
                set: [],
                get: '',
            },
            userError: false,
            totalPoints: '',
            message: '',
            msgError: '',
            tooltip: false,
            popoverWrapper: '',
            creci: '',
            cpfInvalido: 'cpf',
            buttonDisabled: false,
            getLocalStorage: '',
            addCamposPersonalizadosModel: new FormData,
            userModel: '',
            userDataProfile: {},
            userPoints: {},
            fd: new FormData,
            groups: [],
            saveLoading: false
        }
    },

    computed: { 
        ...mapGetters('profile', ['getTypeCampos', 'getCamposPersonalizados', 'setTypeCampos']),
		userId: {
            get() {
			    return this.$route.params.id
            },
            set (value) {
                return value
            }
		}
    },

    watch: {
        '$route'(to, from) {
            if(from) {
                this.carregandoTelaPrincipal = true
                this.getData(this.userId)
            }
        }
    },
    
    mounted () {
        user.getAll('groups').then(res => {
            res.data.map(val => {
                switch (val.name) {
                        case 'admin':
                            this.groups.push({label: 'Administrador', value: val.name, id: val.id, type:'Perfis do Sistema'});
                            break
                        case 'collaborator':    
                            this.groups.push({label: 'Colaborador',   value: val.name, id: val.id, type:'Perfis do Sistema'});
                            break
                        case 'supervisor':
                            this.groups.push({label: 'Supervisor',    value: val.name, id: val.id, type:'Perfis do Sistema'});
                            break
                        case 'manager':
                            this.groups.push({label: 'Gerente',       value: val.name, id: val.id, type:'Perfis do Sistema'});
                            break
                        case 'broker':
                            this.groups.push({label: 'corretor',      value: val.name, id: val.id, type:'Perfis do Sistema'});
                            break    
                    }
                    if (val.name !== "admin" && val.name !== "manager" && val.name !== "supervisor" && val.name !== "broker" && val.name !== "collaborator" && val.name !== "system") {
                            this.groups.push({label: val.name, value: val.name, id: val.id, type:'Perfis Dinâmicos'});           
                    }
            })
        })
    },
    created() {
        this.getLocalStorage = JSON.parse(storage.get('user_logged'))
        //redireciona o usuário se for com o mesmo id para o perfil dele
        if(this.userId == this.getLocalStorage.id) {
            this.$router.push('/perfil')
            this.userId = null
        }
        this.getData(this.userId)
        //modifica o tipo de grupo de usuário
        this.$root.$on('change-user-profile', async value => {
            this.statusClass = 'active'
            this.success = false
            
            await user.create(this.userModel.id, value).then(() => {
                return this.getData(this.userId)
            }).catch ((e) => {
                if(e.data.msg && e.data.msg.includes('Você não pode modificar o perfil de um gerente')) {
                    this.$root.$emit(`alert-msg-open-manager-not-modify`)
                }
                this.closeStatus()
            })
        })
    },
    methods: {
        ...mapActions('profile',['setCamposPersonalizados', 'setAtualizeCamposPersonalizados', 'loadDataTeans']),
        //bloqueia o usuário
        bloquear(value) {
            this.statusClass = 'active'
            this.success = false
            this.fd.set('status', value)
            user.create(this.userModel.id, this.fd).then(() => {
                return this.getData(this.userId)
            }).catch (() => {
                this.closeStatus()
            })
        },
        //mostra os pontos do usuário
        showPointsSidebar() {
            this.$root.$emit('sidebar-open-profile-points-feed')
        },
        openCloseModal(name, type) {
            switch (type) {
                case 'open': {
                    return this.$root.$emit('sidebar-toggle-' + name)
                }
                case 'close': {
                    return this.$root.$emit('modal-close-' + name)
                }
            }    
        },
        //valida o email para ver se é verdadeiro
        validEmail(email) {
            if(email && email.length != 0){
                let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                return re.test(email)
            } else return true
        },
        /**
         * Esconde a imagem de carregamento
         */
        closeStatus() {
            this.statusClass = ''
            this.statusIcon = ''
            this.status = false
            this.error = false
        },
        /**
         * verificação de senha
         */

        mensageErros(erro, msg) {
            /**
             * vendo se o erro esta na senha ou no cpf para desativar o botão e abrir o popover com erros definidos
             */
            switch (erro) {
                case 'senha':
                    if (this.erros.set.indexOf('senha') == -1) {
                        this.erros.set.push('senha')
                    }
                    if (this.erros.set.length != 0) {
                        this.buttonDisabled = true
                        var texto = ''
                        if (this.erros.set[1] && msg) {
                            texto = `${msg} e o CPF está inválido`
                            this.cpfInvalido = 'CPF Inválido'
                        } else if ( this.erros.set[0] && this.erros.set.indexOf('senha') != -1 && msg) {
                            texto = msg
                        }
                        this.message = texto
                    } else {
                        this.buttonDisabled = false
                    }
                    break

                case 'remove-senha':
                    if (this.erros.set.indexOf('senha') != -1) {
                        this.erros.set.splice(
                            this.erros.set.indexOf('senha'),
                            1
                        )
                    }
                    if (this.erros.set.length != 0) {
                        this.buttonDisabled = true
                        this.message = 'CPF esta inválido'
                        this.cpfInvalido = 'CPF Inválido'
                    } else {
                        this.buttonDisabled = false
                        this.cpfInvalido = 'CPF:'
                        this.message = ''
                    }
                    break

                case 'cpf':
                    if (this.erros.set.indexOf('cpf') == -1) {
                        this.erros.set.push('cpf')
                    }
                    if (this.erros.set.length != 0) {
                        this.buttonDisabled = true
                        if (this.erros.set[1] && msg) {
                            texto = `${msg} e o CPF está inválido`
                            this.cpfInvalido = 'CPF Inválido'
                        } else if ( this.erros.set[0] && this.erros.set.indexOf('cpf') != -1 ) {
                            texto = 'CPF está inválido'
                            this.cpfInvalido = 'CPF Inválido'
                        }
                        this.message = texto
                    } else {
                        this.buttonDisabled = false
                    }
                    break

                case 'remove-cpf':
                    if (this.erros.set.indexOf('cpf') != -1) {
                        this.erros.set.splice(this.erros.set.indexOf('cpf'), 1)
                    }
                    if (this.erros.set.length != 0 && msg) {
                        this.message = msg
                        this.cpfInvalido = 'CPF:'
                    } else {
                        this.buttonDisabled = false
                        this.cpfInvalido = 'CPF:'
                        this.message = ''
                    }
                    break
            }
        },
        /**
         * Troca entre as paginas do perfil
         */
        chagePage(pageName) {
            this.atualPage = pageName
        },
        /**
         * retorna um modal de erros
         */
        imageAvatar (value) {
             this.imgAvatar = value
        },
        messagers(msg) {
            this.msgError = msg
            this.$root.$emit(`alert-msg-open-campos-message-error`)
        },
        othersUsers(value) {
            if(value.isDynamicGroup) {
                user.getAll(`groups/dynamics`).then(res => {
                    this.dinamics = []
                    res.data.forEach(val => {
                        this.dinamics.push(val.name)
                    })
                })
            }
        },
        //verifica se existe um id passado por parametro para trazer os dados daquele usuário em especifico
        getData(value) {
			this.loading = true;
            if(value && !isNaN(value)) {
                this.perfilUser(value)
            } else {
                this.perfilUser()
            }
        },
        //retorna os dados do usuário
        async perfilUser(value) {
            let url = value ? user.get(`${value}/edit?q=&per_page=10000`, '') : user.me()
            await url.then(async (response) => {
                if(response?.data?.team) this.loadDataTeans({search: false, data: response.data.team })
                if ((this.getLocalStorage.user_group != 'admin' && this.getLocalStorage.user_group != 'collaborator') && (response.data.user_group == 'admin' && response.data.user_group == 'collaborator')) {
                    this.$router.push('/')
                }
                if (this.getLocalStorage.user_group == 'manager'  &&  response.data.user_group == 'supervisor') {
                    this.$router.push('/')
                }
                this.success = true
                this.statusIcon = 'active'
                setTimeout(() => {
                    this.closeStatus()
                }, 1000)
                if (value) {
                    this.othersUsers(response.data)
                }
                this.$root.$emit('set-user-profile', response.data)
                this.returnData(response)
                this.cleanData = user.dataCleaner(this.dirtyData)
                this.loadData('user'      )
                this.loadData('lastAccess')
                this.loadData('createdAt' )
                this.loadData('imgAvatar' )

				// Checks if the profile being viewed is different from the profile of the logged in user
				if (this.userDataProfile && this.getLocalStorage && (this.userDataProfile.id != this.getLocalStorage.id)) {
					// These groups cannot modify other profiles
					if (['broker', 'manager', 'supervisor'].includes(this.getLocalStorage.user_group)) {
						this.$router.push('/')
					}

					// Collaborator can only modify profiles that are below collaborator permissions
					if (
						this.getLocalStorage.user_group == 'collaborator' && 
						!['broker', 'manager', 'supervisor'].includes(this.userDataProfile.group)
						) {
						this.$router.push('/')
					}
				}
                this.carregandoTelaPrincipal = false
            })
            .catch(() => {
                console.error(
                    'Erro ao tentar Carregar os dados do usuário.'
                )
                this.carregandoTelaPrincipal = false
                this.userError = true
            })
        },
        //trata os dados
        returnData(response) {
            if (response.data.status && response.data.status == 'error') {
                    throw new Error(response.data.msg)
            }
            if (response.data.fields) {
                if (response.data.fields.field_group.length != 0) {
                    response.data.fields.field_group.forEach(res => {
                        res.item_fields_name = res.field.slug.replace(/-/g, '_')
                        this.dangerInput[res.field.slug.replace(/-/g, '_')] = null
                    })
                    this.setCamposPersonalizados(response.data.fields.field_group)
                    this.pagination[4].show = true
                }
            }
            if (response.data.user_group !== 'admin' && response.data.user_group !== 'collaborator') {
                user.getPoints(response.data.id).then(res => {
                    this.totalPoints = res.data
                })
            }
            this.dirtyData = response.data
            this.userDataProfile  = {
                id: response.data.id,
                name: response.data.first_name, 
                group: response.data.user_group,
                creci: response.data.creci,
                uf: response.data.uf,
                email: response.data.email,
                teans: []
            }
            if (response.data.team) {
                if(response.data.team.length) {
                        this.userDataProfile.team = response.data.team.length > 1 ? `Usuário vinculado a ${response.data.team.length} equipes`: response.data.team[0].name
                        response.data.team.map( res => {
                            this.userDataProfile.teans.push({name: res.name})
                        })
                } else {
                    this.userDataProfile.team = response.data.team.name
                }
            } else {
                this.userDataProfile.team = 'Sem equipe'
            }
        },

        /**
         * Carrega em ordem os dados requisitados com base na DataKey
         */
        loadData(dataKey) {
            switch (dataKey) {
                case 'user':
                    this.userModel = this.cleanData
                    this.fd.set('email',       this.userModel.email)
                    this.fd.set('user_group',  this.userModel.user_group)
                    break
                case 'lastAccess':
                    this.lastAccess[0] = new Date(this.userModel.last_login)
                    this.lastAccess[1] = this.lastAccess[0].toLocaleDateString()
                    this.lastAccess[2] = this.lastAccess[0].toLocaleTimeString()
                    break
                case 'createdAt':
                    this.createdAt[0] = new Date(this.userModel.created_at)
                    this.createdAt[1] = this.createdAt[0].toLocaleDateString()
                    this.createdAt[2] = this.createdAt[0].toLocaleTimeString()
                    break
                case 'imgAvatar':
                    // eslint-disable-next-line no-case-declarations
                    let cdnTime = new Date().getTime()
                    this.imgAvatar = this.userModel.photo ? this.getImgCDN(this.userModel.photo) + '?' + this.userModel.id.toString() + cdnTime.toString() : this.getImgCDN()
                    break
            }
        },
        /**
         * Salva a imagem separadamente do formulario
         *
         * Reune os dados e faz a requisição
         */

        formDataValue() {
            for(const key in this.userModel) {
                if(key !== 'photo') this.fd.set(key, this.userModel[key])
            }

            this.getTypeCampos.forEach(res => {
                this.fd.set(`field_value[${res.id}]`, this.setTypeCampos[res.campos]);
            });


            if(this.userModel.password) {
                this.fd.set('password', this.userModel.password     )
            }
            return this.fd
        },
        //salva os dados do usuário
        async userSaved () {
            this.success = false
            await user
                .create(this.userModel.id, this.formDataValue())
                .then(async (response) => {
                    if (response.data.status && response.data.status == 'error') {
                        throw new Error(response.data.msg)
                    }
                    this.success = true
                    this.statusIcon = 'active'
                    this.getData(this.userId)
                    setTimeout(() => {
                        /** Alterar campo no local storage para substituir os dados do usuário */
                            this.loading = false
                            this.closeStatus()
                        if(this.userId && !isNaN(this.userId)) {
                            return
                        } else {
                            this.getLocalStorage.first_name = this.userModel.first_name
                            this.getLocalStorage.creci = this.userModel.creci
                            this.getLocalStorage.uf = this.userModel.uf
                            return storage.set('user_logged', JSON.stringify(this.getLocalStorage))
                        }
                    }, 1500)
                })
                .catch((error) => {
                    this.success = false
                    this.loading = false
                    this.closeStatus()

                    let messages = ''
                    if (error.data && typeof error.data.msg === 'object') {
                        messages = '<ul>'
                        for (const field in error.data.msg) {
                            for (const msg of error.data.msg[field]) {
                                messages += `<li>${msg}</li>`
                            }
                        }
                        messages += '</ul>'

                    } else if (error.data && error.data.msg) {
                        messages = error.data.msg
                    }
                    this.messagers(messages)
                })
        },
         async salveField() {
            let campsRequiredEnpty = []
            let campsEmail = []

            this.getTypeCampos.map(res => {
                Object.keys(this.setTypeCampos).forEach(response => {
                    
                    if(res.campos == response) {
                        if(this.setTypeCampos[res.campos] == '' && res.setRequired) {
                            campsRequiredEnpty.push(true)
                        }
                        else {
                            campsRequiredEnpty.push(false)
                        }
                        if(res.type == 'email' && this.setTypeCampos[res.campos] != '') {
                            if(!this.validEmail(this.setTypeCampos[res.campos])) {
                                this.messagers('email inválido')
                                campsEmail.push(this.validEmail(this.setTypeCampos[res.campos]))
                            }
                        }
                    }
                })
                this.fd.set(`field_value[${res.id}]`, res.value)
            })
            if(campsRequiredEnpty.indexOf(true) != -1) {
                this.$root.$emit(`alert-msg-open-campos-required-profile`)
                this.atualPage = 'campos-personalizados'
            } else if(campsEmail.indexOf(false) != -1) {
                return false
            } 
        },

        async saveData() {
            this.saveLoading = true
            if(this.userModel.first_name == '') {
                this.messagers('Por favor, insira um nome')
            } else if(this.userModel.cpf.length < 14 && this.userModel.cpf != '') {
                this.mensageErros('cpf')
                this.popoverWrapper = 'popover-wrapper'
            }
            else {
                this.statusClass = 'active'
                this.loading = true
                await this.userSaved()
            }
            this.setAtualizeCamposPersonalizados([this.setTypeCampos, this.getTypeCampos])
            if(this.userModel.fields.field_group) {
                await this.salveField()
            }
            this.saveLoading = false
        },
    },
}
</script>

<style lang='stylus' scoped>
    @import 'styles.styl'
</style>
